import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "#fe4c4a",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6884",
		"data-name": "Path 6884",
		d: "M6,19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V9a2.006,2.006,0,0,0-2-2H8A2.006,2.006,0,0,0,6,9ZM18,4H15.5l-.71-.71a1.009,1.009,0,0,0-.7-.29H9.91a1.009,1.009,0,0,0-.7.29L8.5,4H6A1,1,0,0,0,6,6H18a1,1,0,0,0,0-2Z",
		transform: "translate(-5 -3)"
	})
});
export { SvgDeleteIcon as ReactComponent };
